export function getUserInfo() {
  try {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user;
  } catch (error) {
    return null;
  }
}

export function setUserInfo(user) {
  localStorage.setItem("userInfo", JSON.stringify(user));
}

export function setClientId() {
  const id = getUuid();
  localStorage.setItem("clientid", JSON.stringify(id));
}

export function getClientId() {
  try {
    const id = JSON.parse(localStorage.getItem("clientid"));
    return id;
  } catch (error) {
    return null;
  }
}

export function getToken() {
  try {
    const user = JSON.parse(localStorage.getItem("userInfo"));
    return user.token;
  } catch (error) {
    return null;
  }
}

export function getUuid() {
  let len = 32; //32长度
  let radix = 16; //16进制
  let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
    ""
  );
  let uuid = [],
    i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) {
      uuid[i] = chars[0 | (Math.random() * radix)];
    }
  } else {
    let r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}

export function setStorageItem(key, value) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getStorageItem(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch (error) {
    return null;
  }
}
